module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/node_modules/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = vendor